import styled from 'styled-components/macro';

// import helpers
import { getBreakpoint, getColor, getFontWeight } from '../../../util/theme';

const RegisterInputContent = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (min-width: ${getBreakpoint('md')}) {
    width: 60rem;
  }

  div {
    display: flex;
    flex-direction: column;

    padding: 10px 0;

    width: 100%;
  }

  label {
    color: ${getColor('titleGrey')};
    font-size: 2rem;
    font-weight: ${getFontWeight('medium')};
    text-transform: uppercase;
  }

  input {
    color: ${getColor('complimentaryBlue')};
    font-size: 1.6rem;

    height: 40px;
    width: 100%;

    padding: 3px 10px;

    &.error {
      border: 2px solid ${getColor('accentRed')};
    }

    &::placeholder {
      color: ${getColor('medGrey')};
    }
  }

  p {
    text-align: center;

    &.note {
      color: ${getColor('primaryBlue')};
      font-size: 1.6rem;
      text-align: left;
    }

    &.error {
      color: ${getColor('accentRed')};
    }

    &.success {
      color: ${getColor('accentGreen')};
    }
  }
`;

export default RegisterInputContent;
